// Рука-подсказка (HQ-954, И-4; Д10 владельца «раз на раздел»): какие подсказки уже нажаты в этом запуске. Сервер
// перестаёт слать hint после POST world/hint/<key>/seen/, а до ответа и при сбое сети рука не должна висеть — прячем сразу.
import { useSyncExternalStore } from 'react';

const seen = new Set<string>();
const listeners = new Set<() => void>();

/** Спрятать руку подсказки key (тап по подсвеченному разделу). */
export function hideHint(key: string): void {
  if (seen.has(key)) return;
  seen.add(key);
  for (const l of [...listeners]) l();
}

export const hintHidden = (key: string) => seen.has(key);

function subscribe(l: () => void): () => void {
  listeners.add(l);
  return () => { listeners.delete(l); };
}

/** Рука видна: ключ есть и ещё не нажат. */
export function useHintShown(key: string | null | undefined): boolean {
  return useSyncExternalStore(subscribe, () => Boolean(key) && !seen.has(key!), () => Boolean(key) && !seen.has(key!));
}

/** Для тестов: забыть нажатые. */
export function resetHints(): void { seen.clear(); for (const l of [...listeners]) l(); }
